import React from 'react';
import { Column, Section } from '@ydistri/ds';
import CalculationEvaluationSummary from './components/summary/CalculationEvaluationSummary';
import StoreEvaluationsTable from './components/StoreEvaluationsTable/StoreEvaluationsTable';

const StoreEvaluationsSection: React.FC = () => {
  return (
    <Section header="Store evaluation">
      <Column $flexGrow={1} $gap="0.5rem" data-type="store-evaluations-section-content">
        <CalculationEvaluationSummary />
        <StoreEvaluationsTable />
      </Column>
    </Section>
  );
};

export default StoreEvaluationsSection;
